import React, { useEffect, useRef, useState } from "react";
import {
  Container,
  Box,
  Typography,
  Button,
  Avatar,
  Tabs,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Grid2,
  FormControlLabel,
  Checkbox,
  IconButton,
} from "@mui/material";
import {
  Email,
  Edit,
  Folder,
  Delete,
  CheckCircle,
  Notifications,
  CheckCircleOutline,
} from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import {
  activationRemider,
  UpdateAbsent,
  DeleteUserProfileInternal,
  changeUserStatus,
  getSingleInternalResource,
} from "../../redux/Thunk/internalResourceThunk/internalResourceThunk";
import dayjs from "dayjs";
import GenericTable from "../../Components/Ui_elements/GenericTable";
import Btn from "../../Components/Ui_elements/Btn";
import { Grid } from "@mui/material";
import TextFieldComponent from "../../Components/TextFieldComponent";
import PopupModal from "../../Components/Ui_elements/PopupModal";
import EmailClient from "../Admin/A_System/Templates/EmailClient";
import { sendMessage, activateUserProfile } from "../../redux/Thunk/authThunk/login";
import DeleteIcon from "@mui/icons-material/Delete";
import DatePickerComponent from "../../Components/DatePickerComponent";
import APP_CONFIG_URL_ENV from "../../env-config";
import { showSnackbar } from "../../redux/Slice/snackbar/snackbarSlice";
import { getCenteredPopupSize } from "../../Helper/Constants";
import { parseIMobile } from "../../Helper/phone";

const Viewinternal = ({ isProfilePage = false, UId }) => {
  const dispatch = useDispatch();
  const params = useParams();
  const ID = params?.id ? params?.id : UId;
  const navigate = useNavigate();
  const [tabValue, setTabValue] = React.useState(0);
  const { internalResource, edit_internal_resource_data } = useSelector(
    state => state.root.InternalResource
  );

  const [openForDelete, setOpenForDelete] = useState(false);
  const [openEmail, setOpenEmail] = useState(false);
  const emailRef = useRef();
  const [absentList, setAbsentList] = useState([]);
  const [formData, setFormData] = useState({
    dateFrom: "",
    dateTo: "",
    remarks: "",
    multiDay: 0,
    isHoliday: 0,
  });

  const [openStatusConfirm, setOpenStatusConfirm] = useState(false);
  const [pendingStatus, setPendingStatus] = useState(null);
  const [localUserStatus, setLocalUserStatus] = useState(null);

  const [deleteAbsentConfirm, setDeleteAbsentConfirm] = useState({
    open: false,
    index: null,
  });

  const [openActivateConfirm, setOpenActivateConfirm] = useState(false);


  const { width, height, left, top } = getCenteredPopupSize(0.6, 0.7);

  useEffect(() => {
    dispatch(getSingleInternalResource(ID));
  }, []);

  const profileImage = edit_internal_resource_data?.vProfilePic || "";
  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const handleActivationRemider = resource => {
    dispatch(activationRemider(resource));
  };

  const handleProfileActivate = () => {
    setOpenActivateConfirm(true);
  };

  const confirmProfileActivate = () => {
    dispatch(activateUserProfile({ user_id: ID })).then(res => {
      dispatch(getSingleInternalResource(ID));
      setOpenActivateConfirm(false);
    });
  };



  const handleEmail = () => {
    const sendTo = internalResource?.vEmailAddress || "";
    window.location.href = `mailto:${sendTo}`;
    //setOpenEmail(true);
  };

  const mobileParsed = parseIMobile(internalResource?.iMobile);
  const mobileNumber = mobileParsed?.formattedMobileNumber || mobileParsed?.rawMobileNumber || "";
  const leaveDate = internalResource?.is_available
    ? JSON.parse(internalResource?.is_available)
    : [];
  const handleDeleteAbsent__ = indexToRemove => {
    const updatedList = absentList.filter((_, index) => index !== indexToRemove);
    setAbsentList(updatedList);

    const payload = {
      is_available: JSON.stringify(updatedList),
    };

    dispatch(UpdateAbsent({ user_id: ID, ...payload }));
  };

  // Update handleDeleteAbsent to open confirmation
  const handleDeleteAbsent = indexToRemove => {
    setDeleteAbsentConfirm({
      open: true,
      index: indexToRemove,
    });
  };
  // Add confirm delete function
  const handleConfirmDeleteAbsent = () => {
    const { index } = deleteAbsentConfirm;
    const updatedList = absentList.filter((_, i) => i !== index);
    setAbsentList(updatedList);

    const payload = {
      is_available: JSON.stringify(updatedList),
    };

    dispatch(UpdateAbsent({ user_id: ID, ...payload }));
    setDeleteAbsentConfirm({ open: false, index: null });
  };

  const columns = [
    {
      name: "rowNumber",
      label: "No.",
    },
    {
      name: "dateFrom",
      label: "Date From",
      options: {
        customBodyRender: value => dayjs(value).format("DD.MM.YYYY"),
      },
    },
    {
      name: "dateTo",
      label: "Date To",
      options: {
        customBodyRender: value => dayjs(value).format("DD.MM.YYYY"),
      },
    },
    {
      name: "isHoliday",
      label: "Holiday",
      options: {
        customBodyRender: value =>
          value ? <CheckCircleOutline style={{ color: "green" }} /> : null,
      },
    },
    {
      name: "remarks",
      label: "Remarks",
    },
    {
      name: "actions",
      label: "Actions",
      options: {
        customBodyRenderLite: dataIndex => (
          <IconButton color="error" onClick={() => handleDeleteAbsent(dataIndex)}>
            <DeleteIcon />
          </IconButton>
        ),
      },
    },
  ];

  const data = absentList?.map((item, index) => ({
    rowNumber: index + 1,
    id: index + 1,
    dateFrom: item.dateFrom || "",
    dateTo: item.dateTo || "",
    multiDay: item.multiDay || "",
    isHoliday: item.isHoliday || "",
    remarks: item.remarks || "",
  }));

  const handleInputChange = e => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? (checked ? 1 : 0) : value,
    });
  };
  useEffect(() => {
    if (internalResource?.is_available) {
      try {
        const parsedList = JSON.parse(internalResource.is_available);
        setAbsentList(Array.isArray(parsedList) ? parsedList : []);
      } catch (err) {
        setAbsentList([]); // Fallback to empty
      }
    }
  }, [internalResource]);

  const handleSubmitUpdateAbsentSearch = e => {
    e.preventDefault();

    const newEntry = {
      dateFrom: formData.dateFrom,
      dateTo: formData.dateTo,
      multiDay: formData.multiDay,
      isHoliday: formData.isHoliday || 0,
      remarks: formData.remarks || "",
    };

    // Append new entry to the local list
    const updatedList = [...absentList, newEntry];
    setAbsentList(updatedList);

    const payload = {
      is_available: JSON.stringify(updatedList), // Store as stringified array of objects
    };

    dispatch(UpdateAbsent({ user_id: ID, ...payload })).then(() => {
      // dispatch(getSingleInternalResource(ID)); // Refresh from API after update if needed
    });

    // Optional: Reset form
    setFormData({
      dateFrom: "",
      dateTo: "",
      remarks: "",
      multiDay: 0,
      isHoliday: 0,
    });
  };

  const handleReset = () => {
    setFormData({
      dateFrom: "",
      dateTo: "",
      remarks: "",
      multiDay: 0,
      isHoliday: 0,
    });
  };

  const handleEdit = () => {
    navigate(`/manage/internal/${ID}`);
  };
  const handleFileManager = () => {
    window.open(
      `/filemanage/item?userId=${ID}`,
      "FileManagerPopup",
      `width=${width},height=${height},top=${top},left=${left},` +
      "menubar=no,toolbar=no,location=no,status=no,scrollbars=yes,resizable=yes"
    );
  };
  const handleDeleteInternalResource = () => {
    setOpenForDelete(true);
  };
  const handleConfirmDelete = () => {
    const payload = {
      id: ID,
      profile: profileImage,
    };
    dispatch(DeleteUserProfileInternal(payload)).then(() => {
      setOpenForDelete(false);
      navigate("/resources/internal");
    });
  };

  const handleSetAsActive = () => {
    const currentStatus = localUserStatus !== null ? localUserStatus : internalResource?.eUserStatus;
    const newStatus = currentStatus === 3 ? 4 : 3; // Toggle between 3 (active) and 4 (inactive)

    setPendingStatus(newStatus);
    setOpenStatusConfirm(true);
  };

const confirmStatusChange = () => {
  const payload = {
    id: ID,
    eUserStatus: pendingStatus,
  };

  dispatch(changeUserStatus(payload)).then(res => {
      if (res?.type?.includes("fulfilled")) {
        // Check if the API call was successful (status 200)
        if (res?.payload?.status === 200) {
          setLocalUserStatus(pendingStatus);
          dispatch(getSingleInternalResource(ID));   // only for internal
          setOpenStatusConfirm(false);
        } else if (res?.payload?.status === 422) {
          // Backend validation failed - don't update local state
          setOpenStatusConfirm(false);
        }
      }
      setOpenStatusConfirm(false);
    });
  };
  const getUserStatusConfig = status => {
    switch (status) {
      case 3: // Active
        return {
          text: "Set As Inactive",
          color: "success",
          variant: "contained",
          disabled: false,
        };
      case 4: // Inactive
      case 15: // Blacklisted
      default:
        return {
          text: "Set As Active",
          color: "primary",
          variant: "contained",
          disabled: false,
        };
    }
  };

  const handleSubmitMail = async () => {
    if (emailRef.current && emailRef.current.handleSubmit) {
      try {
        const response = await emailRef.current.handleSubmit();
        if (response !== null) {
          dispatch(sendMessage({ id: ID, data: response }));
          setOpenEmail(false); // Close modal on success
        }
      } catch (error) {
        console.error("Failed to send email:", error);
      }
    } else {
      console.error("Email ref or handleSubmit not available");
    }
  };

  useEffect(() => {
    if (internalResource?.eUserStatus !== undefined) {
      setLocalUserStatus(internalResource.eUserStatus);
    }
  }, [internalResource?.eUserStatus]);

  return (
    <Container sx={{ bgcolor: "#f4f0ff", p: 3, borderRadius: 2 }}>
      <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 2 }}>
        <Button variant="contained" onClick={() => navigate(-1)} sx={{ ml: 1, borderRadius: 2 }}>
          Back
        </Button>
      </Box>

      <Box
        sx={{
          p: 2,
          borderRadius: 3,
          background: "#fff",
          overflow: "hidden",
        }}
      >
        {/* Grid container for profile and buttons */}
        <Grid container spacing={1} alignItems="center">
          {/* Profile section */}
          <Grid item xs={12} md={1.5}>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Avatar
                src={
                  internalResource?.S3vProfilePic
                    ? internalResource?.S3vProfilePic
                    : internalResource?.vProfilePic
                    ? `${APP_CONFIG_URL_ENV.REACT_APP_FILEPATH}profilePic/${internalResource?.vProfilePic}`
                    : internalResource?.vProfilePic
                }
                sx={{
                  width: 90,
                  height: 90,
                  mr: 3,
                  border: "3px solid white",
                  boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                }}
              />
            </Box>
          </Grid>

          {/* Buttons section */}
          <Grid item xs={12} md={10.5}>
            <Box>
              <Typography variant="h6" fontWeight="bold">
                {internalResource?.vFirstName + " " + internalResource?.vLastName || "N/A"}
              </Typography>
              <Typography variant="subtitle1" color="text.secondary" sx={{ mt: 0.5 }}>
                I work in the{" "}
                <Box component="span" fontWeight="600">
                  {internalResource?.vResourcePositionName || ""}
                </Box>{" "}
                department
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                flexWrap: "wrap",
                gap: 1,
                mt: 2,
                justifyContent: { xs: "flex-start", md: "flex-start" },
              }}
            >
              <Button
                variant="contained"
                color="primary"
                startIcon={<Email />}
                onClick={handleEmail}
                sx={{ borderRadius: 2 }}
              >
                Email
              </Button>
              <Button
                variant="contained"
                color="secondary"
                onClick={handleEdit}
                startIcon={<Edit />}
                sx={{ borderRadius: 2 }}
              >
                Edit
              </Button>
              <Button
                variant="contained"
                color="info"
                onClick={handleFileManager}
                startIcon={<Folder />}
                sx={{ borderRadius: 2 }}
              >
                File Manager
              </Button>
              {!isProfilePage && (
                <Button
                  variant="contained"
                  color="error"
                  onClick={handleDeleteInternalResource}
                  startIcon={<Delete />}
                  sx={{ borderRadius: 2 }}
                >
                  Delete
                </Button>
              )}
              {!isProfilePage && (
                <Button
                  variant={getUserStatusConfig(localUserStatus).variant}
                  color={getUserStatusConfig(localUserStatus).color}
                  startIcon={<CheckCircle />}
                  sx={{
                    borderRadius: 2,
                    textTransform: "none",
                  }}
                  onClick={() => {
                    if (!getUserStatusConfig(localUserStatus).disabled) {
                      handleSetAsActive();
                    }
                  }}
                >
                  {getUserStatusConfig(localUserStatus).text}
                </Button>
              )}
              {!isProfilePage && internalResource?.activation_status === 0 && (
                <>
                  <Button
                    variant="contained"
                    color="warning"
                    startIcon={<CheckCircle />}
                    onClick={handleProfileActivate}
                    sx={{ borderRadius: 2 }}
                  >
                    Profile Activate
                  </Button>
                  <Button
                    variant="contained"
                    color="secondary"
                    startIcon={<Notifications />}
                    onClick={() => handleActivationRemider(internalResource)}
                    sx={{ borderRadius: 2 }}
                  >
                    Activation Reminder
                  </Button>
                </>
              )}

            </Box>
          </Grid>
        </Grid>
      </Box>

      <Tabs value={tabValue} onChange={handleTabChange} className="custom-tabs">
        <Tab label="Overview" sx={{ color: "purple", "&.Mui-selected": { color: "black" } }} />
        <Tab
          label="Basic Information"
          sx={{
            color: "purple",
            "&.Mui-selected": { color: "black" }, // Active tab color
          }}
        />
        <Tab
          label="Contact Information"
          sx={{
            color: "purple",
            "&.Mui-selected": { color: "black" },
          }}
        />
        <Tab
          label="Absent List"
          sx={{
            color: "purple",
            "&.Mui-selected": { color: "black" },
          }}
        />
      </Tabs>

      <Box sx={{ mt: 1, bgcolor: "#ffffff", p: 1, borderRadius: 1 }}>
        {tabValue === 0 && (
          <Grid container spacing={2} sx={{ mt: 2 }}>
            {/* Box 1 – Basic Info */}
            <Grid item xs={12} md={6}>
              <Box sx={{ p: 2, borderRadius: 2 }}>
                <Typography className="customCardHeader" pl={1}>
                  Basic Information
                </Typography>
                <TableContainer>
                  <Table>
                    <TableBody>
                      <TableRow>
                        <TableCell sx={{ fontWeight: "bold" }}>Name</TableCell>
                        <TableCell>{internalResource.vUserName || "N/A"}</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell sx={{ fontWeight: "bold" }}>Position</TableCell>
                        <TableCell>{internalResource.vResourcePositionName || "N/A"}</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell sx={{ fontWeight: "bold" }}>Gender</TableCell>
                        <TableCell>{internalResource.iGender === 1 ? "Male" : "Female"}</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell sx={{ fontWeight: "bold" }}>Date of Birth</TableCell>
                        <TableCell>
                          {internalResource.dtBirthDate &&
                          internalResource.dtBirthDate !== "0000-00-00" &&
                          dayjs(internalResource.dtBirthDate).isValid() &&
                          !dayjs(internalResource.dtBirthDate).isAfter(dayjs())
                            ? `${dayjs(internalResource.dtBirthDate).format("DD.MM.YYYY")}`
                            : "N/A"}
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </Grid>

            {/* Box 2 – Contact Info */}
            <Grid item xs={12} md={6}>
              <Box sx={{ p: 2, borderRadius: 2 }}>
                <Typography className="customCardHeader" pl={1}>
                  Contact Information
                </Typography>
                <TableContainer>
                  <Table>
                    <TableBody>
                      <TableRow>
                        <TableCell sx={{ fontWeight: "bold" }}>Resource Number</TableCell>
                        <TableCell>00{internalResource?.iResourceNumber || "N/A"}</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell sx={{ fontWeight: "bold" }}>Email</TableCell>
                        <TableCell>{internalResource?.vEmailAddress || "N/A"}</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell sx={{ fontWeight: "bold" }}>Mobile</TableCell>
                        <TableCell>{mobileNumber || "N/A"}</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell sx={{ fontWeight: "bold" }}>Slack/Teams</TableCell>
                        <TableCell>{internalResource?.vSkypeName || "N/A"}</TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </Grid>

            {/* Box 3 – Absent List */}
            <Grid item xs={12} md={12}>
              <Box sx={{ p: 2, borderRadius: 2 }}>
                <Typography className="customCardHeader" pl={1}>
                  Absent List
                </Typography>
                <GenericTable
                  columns={columns}
                  data={data}
                  showAction={false}
                  showDelete={false}
                  displayColumns={columns.length || 4}
                  displayRows={5}
                  showEdit={false}
                  pageTitle={""}
                />
              </Box>
            </Grid>
          </Grid>
        )}
        {tabValue === 1 && (
          <Box sx={{ mt: 2, p: 2 }}>
            <TableContainer>
              <Table>
                <TableBody>
                  <TableRow>
                    <TableCell sx={{ fontWeight: "bold" }}>Name</TableCell>
                    <TableCell>{internalResource.vUserName || "N/A"}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell sx={{ fontWeight: "bold" }}>Position</TableCell>
                    <TableCell>{internalResource.vResourcePositionName || "N/A"}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell sx={{ fontWeight: "bold" }}>Gender</TableCell>
                    <TableCell>{internalResource.iGender === 1 ? "Male" : "Female"}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell sx={{ fontWeight: "bold" }}>Date of Birth</TableCell>
                    <TableCell>
                      {internalResource.dtBirthDate &&
                      internalResource.dtBirthDate !== "0000-00-00" &&
                      dayjs(internalResource.dtBirthDate).isValid() &&
                      !dayjs(internalResource.dtBirthDate).isAfter(dayjs())
                        ? `${dayjs(internalResource.dtBirthDate).format("DD.MM.YYYY")}`
                        : "N/A"}
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        )}
        {tabValue === 2 && (
          <Box sx={{ mt: 2, p: 2 }}>
            <TableContainer>
              <Table>
                <TableBody>
                  <TableRow>
                    <TableCell sx={{ fontWeight: "bold" }}>Resource Number</TableCell>
                    <TableCell>00{internalResource?.iResourceNumber || "N/A"}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell sx={{ fontWeight: "bold" }}>Email Address</TableCell>
                    <TableCell>{internalResource?.vEmailAddress || "N/A"}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell sx={{ fontWeight: "bold" }}>Mobile Number</TableCell>
                    <TableCell>{mobileNumber || "N/A"}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell sx={{ fontWeight: "bold" }}>Slack/Teams</TableCell>
                    <TableCell>{internalResource?.vSkypeName || "N/A"}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell sx={{ fontWeight: "bold" }}>Creation Date</TableCell>
                    <TableCell>
                      {dayjs(internalResource?.dtCreatedDate).format("DD.MM.YYYY") || "N/A"}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell sx={{ fontWeight: "bold" }}>Creator</TableCell>
                    <TableCell>{internalResource?.createdBy || "N/A"}</TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        )}
        {tabValue === 3 && (
          <Grid container spacing={2}>
            <Grid item xs={8}>
              <Box sx={{ p: 2, height: "100%" }}>
                <form>
                  <Grid container spacing={2} alignItems="center">
                    {/* From Date */}
                    <Grid item xs={12} sm={3}>
                      <DatePickerComponent
                        id="dateFrom"
                        name="dateFrom"
                        label="From Date"
                        value={formData.dateFrom}
                        onChange={handleInputChange}
                        fullWidth
                        isNotMandatory={true}
                      />
                    </Grid>

                    {/* To Date */}
                    <Grid item xs={12} sm={3}>
                      <DatePickerComponent
                        id="dateTo"
                        name="dateTo"
                        label="To Date"
                        value={formData.dateTo}
                        onChange={handleInputChange}
                        fullWidth
                        isNotMandatory={true}
                      />
                    </Grid>

                    {/* Remarks */}
                    <Grid item xs={12} sm={4}>
                      <TextFieldComponent
                        name="remarks"
                        label="Remarks"
                        type="text"
                        value={formData.remarks}
                        onChange={handleInputChange}
                        fullWidth
                        isNotMandatory={true}
                      />
                    </Grid>

                    {/* Holiday checkbox */}
                    <Grid item xs={12} sm={2} mt={2}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            name="isHoliday"
                            checked={formData.isHoliday}
                            onChange={handleInputChange}
                          />
                        }
                        label="Holiday"
                      />
                    </Grid>
                  </Grid>

                  {/* Buttons */}
                  <Grid container spacing={2} mt={2}>
                    <Grid item>
                      <Btn onClick={handleSubmitUpdateAbsentSearch}>Save</Btn>
                    </Grid>
                    <Grid item>
                      <Btn onClick={handleReset}>Reset</Btn>
                    </Grid>
                  </Grid>
                </form>
              </Box>
            </Grid>
            <Grid item xs={12}>
              <GenericTable
                columns={columns}
                data={data}
                showAction={false}
                showDelete={false}
                displayColumns={columns.length || 4}
                displayRows={10}
                showEdit={false}
                pageTitle={"Absent List"}
              />
            </Grid>
          </Grid>
        )}
        {openForDelete && (
          <PopupModal
            maxWidth={"xs"}
            size={"sm"}
            width="650px"
            fullWidth={false}
            open={openForDelete}
            handleClose={() => setOpenForDelete(false)}
            actions={
              <Grid container columnGap={2} justifyContent={"end"}>
                <Btn onClick={() => handleConfirmDelete()}>Yes</Btn>
                <Btn onClick={() => setOpenForDelete(false)}>Cancel</Btn>
              </Grid>
            }
            title={
              <Typography variant="h6">Are you sure you want to delete this resource? </Typography>
            }
          >
            <Typography>
              Please note that all information in this resource profile will be deleted.
            </Typography>
          </PopupModal>
        )}
        {openEmail && (
          <PopupModal
            open={openEmail}
            maxWidth="lg"
            title="Mail"
            handleClose={() => setOpenEmail(false)}
            actions={
              <>
                <Btn onClick={handleSubmitMail}>Send Mail</Btn>
                <Btn variant="outlined" onClick={() => setOpenEmail(false)}>
                  Cancel
                </Btn>
              </>
            }
          >
            <Typography variant="body1">
              <EmailClient
                ref={emailRef}
                general={true}
                invoiceNumber={internalResource?.vUserName}
                email={internalResource?.vEmailAddress || ""}
                showFromProfile={true}
              />
            </Typography>
          </PopupModal>
        )}
        {openStatusConfirm && (
          <PopupModal
            maxWidth={"sm"}
            size={"sm"}
            width="650px"
            fullWidth={true}
            open={openStatusConfirm}
            handleClose={() => setOpenStatusConfirm(false)}
            actions={
              <Grid container columnGap={2} justifyContent={"end"}>
                <Btn onClick={confirmStatusChange}>Yes</Btn>
                <Btn onClick={() => setOpenStatusConfirm(false)}>Cancel</Btn>
              </Grid>
            }
            title={
              <Typography variant="h6">
                {pendingStatus === 3 ? "Activate User" : "Deactivate User"}
              </Typography>
            }
          >
            <Typography>
              Are you sure you want to {pendingStatus === 3 ? "activate" : "deactivate"} this user?
            </Typography>
          </PopupModal>
        )}

        {deleteAbsentConfirm.open && (
          <PopupModal
            maxWidth={"xs"}
            size={"sm"}
            width="650px"
            fullWidth={false}
            open={deleteAbsentConfirm.open}
            handleClose={() => setDeleteAbsentConfirm({ open: false, index: null })}
            actions={
              <Grid container columnGap={2} justifyContent={"end"}>
                <Btn onClick={handleConfirmDeleteAbsent} color="error">
                  Yes, Delete
                </Btn>
                <Btn onClick={() => setDeleteAbsentConfirm({ open: false, index: null })}>
                  Cancel
                </Btn>
              </Grid>
            }
            title={<Typography variant="h6">Delete Absent Record</Typography>}
          >
            <Typography>Are you sure you want to delete this absent record?</Typography>
          </PopupModal>
        )}
        {openActivateConfirm && (
          <PopupModal
            maxWidth={"sm"}
            size="sm"
            width="500px"
            fullWidth={true}
            open={openActivateConfirm}
            handleClose={() => setOpenActivateConfirm(false)}
            actions={
              <Grid container columnGap={2} justifyContent={"end"}>
                <Btn onClick={confirmProfileActivate}>Yes</Btn>
                <Btn variant="outlined" onClick={() => setOpenActivateConfirm(false)}>
                  Cancel
                </Btn>
              </Grid>
            }
            title={<Typography variant="h6">Activate Profile</Typography>}
          >
            <Typography variant="body1">Are you sure you want to activate this user profile?</Typography>
          </PopupModal>
        )}
      </Box>
      {/* <Typography variant="body2" align="left" sx={{ mt: 4, color: "gray" }}>
        &copy; 2015 Copyright.
      </Typography> */}
    </Container>
  );
};

export default Viewinternal;
